export function resolvePostLoginDestination(
  redirectTo: string,
  role: string | null | undefined,
): string {
  const destination = redirectTo.trim();
  const hasExplicitRedirect = destination.length > 0 && destination !== "/";
  if (hasExplicitRedirect) return destination;

  if (role === "admin") return "/dashboard";
  if (role === "therapist") return "/dashboard/therapist";
  return "/";
}
